import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from "@angular/core";
import { AppService } from "@irb/app.service";
import { IrbClientsEvents } from "@irb/irb-common/events";
import { OptionsFormatterService } from "../../options-formatter.service";
import { RollCoveredcallSettingsComponent } from "./roll-coveredcall-settings.component";

@Component({ standalone: false,
    selector: 'option-to-open-cell-renderer',
    template: `
        @if (!isReadOnly) {
          <a (click)="selectOptionToOpen()">{{optionToOpen}}</a>
        }
        @if (isReadOnly) {
          <span>{{optionToOpen}}</span>
        }
        `
})
export class OptionToOpenCellRenderer implements ICellRendererAngularComp {

    _params: any;
    _optionToOpen: string;
    _isReadOnly: boolean = false;
    
    componentParent: any;

    constructor(public as: AppService, 
        public optionFormatter: OptionsFormatterService) {}

    agInit(params: any): void {
        this.params = params;
        this.componentParent = this.params.context.componentParent;

        //this.optionToOpen = this.optionFormatter.printOptionSymbol(this.params.value);
        if (this.params.data.optionSymbolToRollTo !== null && this.params.data.optionSymbolToRollTo !== undefined) {
            this.optionToOpen = this.optionFormatter.printOptionSymbol(this.params.data.optionSymbolToRollTo);
        } else {
            this.optionToOpen = "Select from Option Chain"
        }
        
        if (this.params.data.allocationId !== null && this.params.data.allocationId !== undefined && this.params.data.allocationId > 0) {
            this.isReadOnly = true;
        }
    }

    refresh(params: any): boolean {
        this.params = params;
        this.componentParent = this.params.context.componentParent;
        
        if (this.params.data.optionSymbolToRollTo !== null && this.params.data.optionSymbolToRollTo !== undefined) {
            this.optionToOpen = this.optionFormatter.printOptionSymbol(this.params.data.optionSymbolToRollTo);
        } else {
            this.optionToOpen = "Select from Option Chain"
        }
        
        if (this.params.data.allocationId !== null && this.params.data.allocationId !== undefined && this.params.data.allocationId > 0) {
            this.isReadOnly = true;
        }

        return true;
    }

    selectOptionToOpen() {
        const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
        this.componentParent.editedRowIndex = rowIndex;
        this.componentParent.isOptnSymbToRollModified = true;
        this.as.fireEvent(IrbClientsEvents.SHOW_OPTION_CHAINS_DIALOG, {
            data: {
                action: 'ROLL_COVER_CALL', 
                underlyingSymbol: this.params.data.underlyingSymbol, 
                chainType: this.getChainType(),
                isChainTypeDisable: true,
                isTrayVisible: false
            }
        });
    }

    getChainType() {
        let chainType: string = "ALL";
        if (this.params.data.optionSelectionMode) {
            switch(this.params.data.optionSelectionMode) {
                case 'ALL_CALLS':
                    chainType = "CALL";
                    break;
                case 'ALL_PUTS':
                    chainType = "PUT";
                    break;
                case 'OPTION_CHAIN':
                    if (this.params.data.optionSymbol !== null && this.params.data.optionSymbol !== undefined) {
                        chainType = this.componentParent.optionFormatter.getPutCallIndicator(this.params.data.optionSymbol);
                    }
                    break;
            }
        }
        return chainType;
    }

    set params(params: any) {
        this._params = params;
    }

    get params() {
        return this._params;
    }

    set optionToOpen(optionToOpen: string) {
        this._optionToOpen = optionToOpen;
    }

    get optionToOpen() {
        return this._optionToOpen;
    }

    set isReadOnly(isReadOnly: boolean) {
        this._isReadOnly = isReadOnly;
    }

    get isReadOnly() {
        return this._isReadOnly;
    }

}
